/**
 * Application configuration
 */

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
  mockApiUrl: import.meta.env.VITE_MOCK_API_URL || 'https://jsonplaceholder.typicode.com',
  /** Akashic Data Pipeline (ADP) service base URL */
  adpApiUrl: import.meta.env.VITE_ADP_API_URL || 'https://api-dev.akashic.dhira.io/adp/api/v1',
  /**
   * Ingestion API base (file upload, showTables, showDataTypes) — same path layout as Akashic-revamped-ui.
   * When unset, falls back to `VITE_ADP_API_URL` / adp base.
   */
  ingestionApiUrl: import.meta.env.VITE_INGESTION_API_URL || import.meta.env.VITE_ADP_API_URL || 'https://api-dev.akashic.dhira.io/core/api/v1',
  /** Sent as `x-tenant-name` on ADP API requests */
  adpTenantName: import.meta.env.VITE_ADP_TENANT_NAME || 'tenanta',
  /** WebSocket base URL for job monitoring */
  adpWebSocketUrl: import.meta.env.VITE_ADP_WEBSOCKET_URL || 'wss://api-dev.akashic.dhira.io/websocket',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  appName: 'React Template',
  version: '1.0.0',
  tenantId: import.meta.env.VITE_TENANT_ID || 'uber',
} as const

/**
 * Feature flags
 */
export const featureFlags = {
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableDevTools: import.meta.env.DEV,
  enableMockApi: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
} as const

